export default class DriveEditableSettings {
  isStartDateEditable!: boolean;
  isEndDateEditable!: boolean;
  isDriverEditable!: boolean;
  isBillingEditable!: boolean;
  isRequestedTypeEditable!: boolean;
  isCommentEditable!: boolean;
  canCheckIn!: boolean;
  canCheckOut!: boolean;
}
